/**
 * @generated SignedSource<<9bbe6488f4a29efbdc1990d8a6972b73>>
 * @lightSyntaxTransform
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type UpdateVaccinationStatusCriteriaInput = {
  clientMutationId?: string | null | undefined;
  vaccinationStatusIds?: ReadonlyArray<any | null | undefined> | null | undefined;
};
export type useVaccinationStatusCriteriaMutation$variables = {
  input: UpdateVaccinationStatusCriteriaInput;
};
export type useVaccinationStatusCriteriaMutation$data = {
  readonly updateVaccinationStatusCriteria: {
    readonly query: {
      readonly " $fragmentSpreads": FragmentRefs<"useVaccinationStatusCriteria_query">;
    } | null | undefined;
  } | null | undefined;
};
export type useVaccinationStatusCriteriaMutation = {
  response: useVaccinationStatusCriteriaMutation$data;
  variables: useVaccinationStatusCriteriaMutation$variables;
};

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "input"
  }
],
v1 = [
  {
    "kind": "Variable",
    "name": "input",
    "variableName": "input"
  }
],
v2 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "id",
  "storageKey": null
};
return {
  "fragment": {
    "argumentDefinitions": (v0/*:: as any*/),
    "kind": "Fragment",
    "metadata": null,
    "name": "useVaccinationStatusCriteriaMutation",
    "selections": [
      {
        "alias": null,
        "args": (v1/*:: as any*/),
        "concreteType": "UpdateVaccinationStatusCriteriaPayload",
        "kind": "LinkedField",
        "name": "updateVaccinationStatusCriteria",
        "plural": false,
        "selections": [
          {
            "alias": null,
            "args": null,
            "concreteType": "Query",
            "kind": "LinkedField",
            "name": "query",
            "plural": false,
            "selections": [
              {
                "args": null,
                "kind": "FragmentSpread",
                "name": "useVaccinationStatusCriteria_query"
              }
            ],
            "storageKey": null
          }
        ],
        "storageKey": null
      }
    ],
    "type": "Mutation",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*:: as any*/),
    "kind": "Operation",
    "name": "useVaccinationStatusCriteriaMutation",
    "selections": [
      {
        "alias": null,
        "args": (v1/*:: as any*/),
        "concreteType": "UpdateVaccinationStatusCriteriaPayload",
        "kind": "LinkedField",
        "name": "updateVaccinationStatusCriteria",
        "plural": false,
        "selections": [
          {
            "alias": null,
            "args": null,
            "concreteType": "Query",
            "kind": "LinkedField",
            "name": "query",
            "plural": false,
            "selections": [
              {
                "alias": null,
                "args": null,
                "concreteType": "User",
                "kind": "LinkedField",
                "name": "currentUser",
                "plural": false,
                "selections": [
                  {
                    "alias": null,
                    "args": [
                      {
                        "kind": "Literal",
                        "name": "orderBy",
                        "value": [
                          "VACCINATION_STATUS_BY_VACCINATION_STATUS_ID__SEQUENCE_ASC"
                        ]
                      }
                    ],
                    "concreteType": "VaccinationStatusCriterionConnection",
                    "kind": "LinkedField",
                    "name": "vaccinationStatusCriteria",
                    "plural": false,
                    "selections": [
                      {
                        "alias": null,
                        "args": null,
                        "concreteType": "VaccinationStatusCriterion",
                        "kind": "LinkedField",
                        "name": "nodes",
                        "plural": true,
                        "selections": [
                          {
                            "alias": null,
                            "args": null,
                            "kind": "ScalarField",
                            "name": "vaccinationStatusId",
                            "storageKey": null
                          },
                          (v2/*:: as any*/)
                        ],
                        "storageKey": null
                      }
                    ],
                    "storageKey": "vaccinationStatusCriteria(orderBy:[\"VACCINATION_STATUS_BY_VACCINATION_STATUS_ID__SEQUENCE_ASC\"])"
                  },
                  (v2/*:: as any*/)
                ],
                "storageKey": null
              },
              (v2/*:: as any*/)
            ],
            "storageKey": null
          }
        ],
        "storageKey": null
      }
    ]
  },
  "params": {
    "cacheID": "70075b948b42fbb3ad24fdb6a4442bb4",
    "id": null,
    "metadata": {},
    "name": "useVaccinationStatusCriteriaMutation",
    "operationKind": "mutation",
    "text": "mutation useVaccinationStatusCriteriaMutation(\n  $input: UpdateVaccinationStatusCriteriaInput!\n) {\n  updateVaccinationStatusCriteria(input: $input) {\n    query {\n      ...useVaccinationStatusCriteria_query\n      id\n    }\n  }\n}\n\nfragment useVaccinationStatusCriteria_query on Query {\n  currentUser {\n    vaccinationStatusCriteria(orderBy: [VACCINATION_STATUS_BY_VACCINATION_STATUS_ID__SEQUENCE_ASC]) {\n      nodes {\n        vaccinationStatusId\n        id\n      }\n    }\n    id\n  }\n}\n"
  }
};
})();

(node as any).hash = "123a1d94a2ad7dd0d58c82cffd1d6055";

export default node;
